// extracted by mini-css-extract-plugin
export default {"switch":"switch-h2k09","icon":"icon-sHwza","active":"active-b0OXf"};